import { render, staticRenderFns } from "./orderPreview.vue?vue&type=template&id=c861b82c&scoped=true&"
import script from "./orderPreview.vue?vue&type=script&lang=js&"
export * from "./orderPreview.vue?vue&type=script&lang=js&"
import style0 from "./orderPreview.vue?vue&type=style&index=0&id=c861b82c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c861b82c",
  null
  
)

export default component.exports